import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { useStatsigClient } from "@statsig/react-bindings";

import { HOMEPAGE_CONTENT_FEED } from "../../GraphQL/homepage";
import { SUGGESTED_CREATORS } from "../../GraphQL/suggestedCreators";
import { useUser } from "../../Hooks/useUser";

const limit = 12;

const HomepageViewModel = () => {
  const { allstarUser } = useUser();
  const { getExperiment } = useStatsigClient();
  const startDate = useMemo(
    () => String(new Date(new Date().setMonth(new Date().getMonth() - 12))),
    [],
  );

  let personalized = false;
  if (allstarUser.loggedIn) {
    personalized = getExperiment("personalized_for_you").get(
      "personalized",
      false,
    );
  }

  const { data: contentFeeds, loading: contentFeedsLoading } = useQuery(
    HOMEPAGE_CONTENT_FEED(personalized),
    {
      variables: {
        limit,
        search: "popular",
        startDate,
      },
      fetchPolicy: "cache-and-network",
    },
  );

  const { data: suggestedData, loading: suggestedLoading } = useQuery(
    SUGGESTED_CREATORS,
    { fetchPolicy: "network-only", variables: { count: 12 } },
  );

  return {
    allstarUser,
    contentFeeds,
    contentFeedsLoading,
    suggested: suggestedData?.suggestedCreators,
    suggestedLoading,
  };
};

export { HomepageViewModel };
